var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlatArrowRight = function SvgFlatArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 13,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "flat-arrow-right_svg__a",
    width: 33,
    height: 13,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.313 12.763V0H0v12.763z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flat-arrow-right_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m31.913 7.313.034-.034c.133-.133.232-.3.3-.482V6.78l.016-.033v-.033a1.07 1.07 0 0 0 0-.65v-.033l-.017-.033v-.017a1.3 1.3 0 0 0-.3-.482L26.887.438c-.5-.5-1.299-.5-1.782 0-.499.5-.499 1.298 0 1.781l2.897 2.913H1.265C.565 5.132 0 5.698 0 6.398c0 .682.566 1.248 1.265 1.248h26.736l-2.946 2.964c-.5.482-.5 1.281 0 1.78.482.484 1.281.484 1.78 0z",
    clipRule: "evenodd"
  }))));
};
export default SvgFlatArrowRight;